import React from 'react'
import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../_metronic/helpers'
import Dropzone from 'react-dropzone'

const SupportTicketPopup = ({show, handleClose}: any) => {
  // function handleClose(): void {
  //     throw new Error('Function not implemented.')
  // }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-750px'
        className='vh-100'
        show={show}
        onHide={handleClose}
      >
        <div className='modal-header justify-content-center no-border pb-0'>
          <div>
            <h2 className='text-center mt-7 mb-3'>Create Ticket</h2>
            <p className='text-muted fs-6'>
              If you need more info, please check{' '}
              <span className='fw-bold'>Support Guidelines.</span>
            </p>
          </div>
          <div
            className='btn btn-icon btn-sm'
            style={{position: 'absolute', top: '20px', right: '20px'}}
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-10 pt-5'>
          <div className='row mt-7'>
            <div className='col-md-12'>
              <label className=' col-form-label required fw-bold fs-6'>Subject</label>
              <input
                name='subject'
                value={''}
                type='text'
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Enter your ticket subject'
              />
            </div>
          </div>

          <div className='row mt-7'>
            <div className='col-md-6'>
              <label className=' col-form-label required fw-bold fs-6'>Product</label>
              <select className='form-select bg-light-primary border-0 py-4'>
                <option value='1' selected>
                  Select a Product
                </option>
                <option value='2'>Product1</option>
                <option value='3'>Product2</option>
                <option value='4'>Product3</option>
              </select>
            </div>
            <div className='col-md-6'>
              <label className=' col-form-label required fw-bold fs-6'>Assign</label>
              <select className='form-select bg-light-primary border-0 py-4'>
                <option value='1' selected>
                  Select a team member
                </option>
                <option value='2'>Member1</option>
                <option value='3'>Member2</option>
                <option value='4'>Member3</option>
              </select>
            </div>
          </div>
          <div className='row mt-7'>
            <div className='col-md-6'>
              <label className=' col-form-label required fw-bold fs-6'>Status</label>
              <select className='form-select bg-light-primary border-0 py-4'>
                <option value='1' selected>
                  Open
                </option>
                <option value='2'>Close</option>
              </select>
            </div>
            <div className='col-md-6'>
              <label className=' col-form-label required fw-bold fs-6'>Due Date</label>
              <select className='form-select bg-light-primary border-0 py-4'>
                <option value='1' selected>
                  Select a date
                </option>
              </select>
            </div>
          </div>
          <div className='row mt-7'>
            <div className='col-md-12'>
              <label className=' col-form-label required fw-bold fs-6'>Description</label>
              <textarea
                name='Description'
                value={''}
                className='form-control form-control-lg form-control-solid mb-3 mb-lg-0'
                placeholder='Type your ticket description'
                rows={4}
              />
            </div>
          </div>
          <div className='row mt-7'>
            <div className='col-md-12'>
              <label className=' col-form-label required fw-bold fs-6'>Attachments</label>
              <Dropzone onDrop={() => console.log()}>
                {({getRootProps, getInputProps}) => (
                  <section className='dragAndDrop'>
                    <KTSVG path={'/media/svg/dragandDrop.svg'} className='svg-icon-3x me-3' />
                    <div {...getRootProps()}>
                      <input {...getInputProps()} />
                      <span className='fs-7 d-block fw-boldest'>
                        Drop files here or click to upload
                      </span>
                      <span className='text-muted fs-7'>csv,xlsx</span>
                    </div>
                  </section>
                )}
              </Dropzone>
            </div>
          </div>

          <div className='row mt-7 align-items-center'>
            <div className='col-md-6'>
              <label className=' col-form-label required fw-bold fs-6 pb-0'>Notifications</label>
              <p className='text-muted fs-7'>Allow Notification by Phone or Email</p>
            </div>
            <div className='col-md-6'>
              <div className='d-flex justify-content-end'>
                <div className='form-check form-check-sm form-check-custom form-check-solid me-10'>
                  <input
                    className='form-check-input me-3'
                    id='stagger'
                    type='checkbox'
                    data-kt-check='true'
                  />
                  <div>
                    <label htmlFor='stagger' style={{lineHeight: '0.65'}}>
                      Email
                    </label>
                  </div>
                </div>
                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                  <input
                    className='form-check-input me-3'
                    id='stagger'
                    type='checkbox'
                    data-kt-check='true'
                  />
                  <div>
                    <label htmlFor='stagger' style={{lineHeight: '0.65'}}>
                      Phone
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex justify-content-center mt-10'>
            <div id='kt_drawer_chat_close'>
              <button
                type='button'
                onClick={handleClose}
                className='btn btn-sm me-2 w-100px p-3 fw-500 me-4 gray_bg_purple'
              >
                Cancel
              </button>
            </div>

            <button
              type='submit'
              className='btn btn-sm btn-light btn-primary fw-500   w-100px p-3 border border-primary'
            >
              <span className='indicator-label'>Submit</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default SupportTicketPopup
